import AbortController from "abort-controller";

var controllers = [];

class WebService {
    constructor(base_url, token) {
        this.baseUrl = base_url;
        this.token = token;

        if (token) {
            this.headers = {
                Authorization: `Bearer ${this.token}`,
                Accept: "application/json",
                "Content-Type": "application/json"
            };
        } else {
            this.headers = {
                Accept: "application/json",
                "Content-Type": "application/json"
            };
        }
    }

    get(path, signal) {
        return new Promise(resolve => {
            resolve(
                fetch(`${this.baseUrl}${path}`, {
                    method: "GET",
                    signal,
                    headers: this.headers
                })
                    .then(response => response)
                    .catch(error => {
                        throw error;
                    })
            );
        });
    }

    post(path, signal, data) {
        return new Promise(resolve => {
            resolve(
                fetch(`${this.baseUrl}${path}`, {
                    method: "POST",
                    signal,
                    headers: this.headers,
                    body: data
                })
                    .then(response => response)
                    .catch(error => {
                        throw error;
                    })
            );
        });
    }

    put(path, signal, data) {
        return new Promise(resolve => {
            resolve(
                fetch(`${this.baseUrl}${path}`, {
                    method: "PUT",
                    signal,
                    headers: this.headers,
                    body: data
                })
                    .then(response => response)
                    .catch(error => {
                        throw error;
                    })
            );
        });
    }

    abortAndGetNewSignal = key => {
        var controller = controllers.filter(c => c.key === key)[0];

        if (controller) {
            controller.c.abort();
            controller.c = new AbortController();
            return controller.c.signal;
        } else {
            controllers.push({ key: key, c: new AbortController() });
        }
    };
}

export default new (class {
    get rma() {
        const baseUrl = process.env.REACT_APP_WS_RMA;
        const token = window.localStorage.getItem("-rma-jwt");
        return new WebService(baseUrl, token);
    }
})();
